import tableFilters from './table__filters';
export default tableFilters;